import script from "./WeeklyActualRevenueContent.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyActualRevenueContent.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyActualRevenueContent.vue?vue&type=style&index=0&id=795c50d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795c50d0"]])

export default __exports__